"use strict";import{tag as s}from"../custom-tag.js";export function checkThickIcon({height:t=16,width:e=16,hidden:r=!1,title:l="Check thick"}={}){return s`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${e}
      height=${t}
      fill="currentColor"
      viewBox="0 0 12 12"
      aria-hidden="${r?"true":"false"}"
      role="img"
      aria-label="${l}"
    >
      <mask
        id="check-thick_svg__mask0_6108_8901"
        width="12"
        height="9"
        x="0"
        y="2"
        maskUnits="userSpaceOnUse"
        style="mask-type:alpha"
      >
        <path
          fill="currentColor"
          stroke="currentColor"
          stroke-width=".5"
          d="m4.682 8.35 5.663-5.663.177-.177.177.177.62.621.178.177-.177.177-6.15 6.15zm0 0L1.655 5.323l-.176-.177-.177.177-.621.62-.177.178.177.176 3.514 3.515.177-.177z"
        />
      </mask>
      <g mask="url(#check-thick_svg__mask0_6108_8901)">
        <path fill="currentColor" d="M12 .007H0v12h12z" />
      </g>
    </svg>
  `}
//# sourceMappingURL=checkThick.js.map
